import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.4.11_@babel+core@7.29.0_@playwright+test@1.56.1_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.77.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.4.11_@babel+core@7.29.0_@playwright+test@1.56.1_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.77.4/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["HeroBannerPlayBlock"] */ "/app/src/components/frontend/HeroBannerPlayBlock.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/shared/AnimatedProgressBars.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Product360View"] */ "/app/src/components/shared/Product360View.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TimelineSection"] */ "/app/src/components/shared/TimelineSection.tsx");
